import { makeStyles, mergeClasses } from '@fluentui/react-make-styles';
import { HighContrastSelector } from '@fluentui/style-utilities';

// eslint-disable-next-line no-restricted-imports
import {
  commonHighContrastBackgroundHoverFocus,
  commonHighContrastColorDisabled,
  commonHighContrastColorHoverFocus,
  commonHighContrastOutlineToggledOn,
} from '@1js/acui-common/lib/styling/next/commonStyles';

import { useRibbonButtonStyles } from '../../RibbonButton/next/useRibbonButtonStyles';
import { RibbonToggleButtonState } from './RibbonToggleButton.types';

const useStyles = makeStyles({
  checked: _ => ({
    background: 'rgb(225, 223, 221)',
    color: 'rgb(37, 36, 35)',

    [HighContrastSelector]: {
      ...commonHighContrastBackgroundHoverFocus,
      ...commonHighContrastColorHoverFocus,
      ...commonHighContrastOutlineToggledOn,
    },
  }),
  disabled: _ => ({
    [HighContrastSelector]: {
      ...commonHighContrastColorDisabled,
      ':focus': {
        ...commonHighContrastColorDisabled,
      },
    },
  }),
});

export const useRibbonToggleButtonStyles = (state: RibbonToggleButtonState): RibbonToggleButtonState => {
  const styles = useStyles();

  state.root.className = mergeClasses(
    state.checked && styles.checked,
    (state.disabled || state.disabledFocusable) && styles.disabled,
    state.root.className
  );

  useRibbonButtonStyles(state);

  return state;
};
